<template>
  <layout-content>
    <template #toolbar>
      <section class="toolbar-btn">
        <el-button
          type="orange"
          icon="el-icon-plus"
          size="small"
          @click="onOpenEditor()"
        >新建{{editName}}</el-button>
      </section>
   </template>

    <template #body>
      <data-wrapper>
        <el-table
          ref="table"
          :data="list"
          height="100%"
          border
          stripe
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
          style="width: 100%"
          @selection-change="onSelectionChange"
          @row-click="onOpenEditor"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="{$index}">{{$index + 1}}</template>
          </el-table-column>

          <el-table-column prop="name" label="分组名称" />

          <el-table-column prop="iconId" label="图标">
            <template slot-scope="{row}">
              <span :class="`${iconMap[row.iconId] ? iconMap[row.iconId].icon : ''}`"></span>
            </template>
          </el-table-column>>

          <!-- v-if="isAdmin" -->
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="{row}">
              <div class="table-operator-wrapper">
                <span class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
                  <i class="el-icon-delete" aria-hidden="true"></i>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </data-wrapper>
    </template>

    <template #editor>
      <editor
        ref="editor"
        :icon-options="iconOptions"
        @save="getList"
        @close="onCancelHighlightTableRow"
      />
    </template>
  </layout-content>
</template>

<script>
import BaseListEditor from '../../../BaseListEditor'
import Editor from './Editor'

export default {
  name: 'SystemSettingsEnvGroup',
  routeInfo: {
    label: '动环分组',
    icon: 'fa fa-database',
    curdInfo: {
      api: 'EnvCategory',
      id: 'id',
      name: 'name',
      editName: '动环分组'
    }
  },
  extends: BaseListEditor,
  components: {Editor},
  data () {
    return {
      iconOptions: []
    }
  },
  computed: {
    iconMap () {
      return this.iconOptions.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})
    }
  },
  methods: {
    getIcon () {
      this.$api.Icon.getList({type: 'env'}).then(data => {
        this.iconOptions = Object.freeze(data)
        this.getList()
      }).catch(console.error)
    }
  },
  created () {
    this.getIcon()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/08EnvGroup/index.vue